import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export type CompanyLookupResultType = {
  name: string;
  nip: string;
  regon: string | null;
  address: string | null;
  postalCode: string | null;
  city: string | null;
};

const lookupCompanyByNip = async (
  nip: string
): Promise<CompanyLookupResultType> => {
  const res = await axiosInstance.get(`/companies/nip/${nip}`);
  return res.data as CompanyLookupResultType;
};

export const useLookupCompanyByNip = (
  options?: UseMutationOptions<CompanyLookupResultType, Error, string>
) => {
  return useMutation({
    mutationKey: ["lookupCompanyByNip"],
    mutationFn: lookupCompanyByNip,
    ...options,
  });
};

export default useLookupCompanyByNip;
